import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import React from 'react';
import { useDefaultDialogStyles } from 'components/Modals/styles';

export const DefaultDialog = ({
  open,
  onClose,
  children,
  actions,
  title,
  maxWidth = false,
  ...props
}) => {
  const { classes } = useDefaultDialogStyles();

  return (
    <Dialog
      className={classes.modalPaper}
      open={open}
      onClose={onClose}
      aria-labelledby="form-dialog-title"
      maxWidth={maxWidth}
      {...props}
    >
      <DialogTitle id="form-dialog-title">{title}</DialogTitle>
      <DialogContent>{children}</DialogContent>
      {!!actions && (
        <DialogActions className={classes.dialogActions}>
          {actions()}
        </DialogActions>
      )}
    </Dialog>
  );
};
